(function () {
  function attachScrollAnimation(el, delay) {
    el.classList.add('ptc_button--will-animate');
    var observer = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        setTimeout(function() {
          el.classList.remove('ptc_button--will-animate');
          el.classList.add('ptc_button--animate-in');
        }, delay || 0);
        obs.disconnect();
      });
    }, { threshold: 0.3 });
    observer.observe(el);
  }

  var pencilIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"' +
    ' fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/>' +
    '</svg>';

  function transformBtn(btn) {
    // Skip if already transformed
    if (btn.querySelector('.personalize-card__headline')) return;

    // Read price from original text before overwriting: "Personalize (+$10)" → "+$10"
    var text = btn.textContent.trim();
    var match = text.match(/\(([^)]+)\)/);
    var price = match ? match[1] : null;

    // Replace inner content only — onclick attribute on the button element is
    // preserved, so the Zepto personalization modal continues to fire normally.
    btn.innerHTML =
      '<span class="personalize-card__left">' +
        pencilIcon +
        '<span class="personalize-card__text">' +
          '<span class="personalize-card__headline">Make it yours</span>' +
          '<span class="personalize-card__subtext">Custom personalization available</span>' +
        '</span>' +
      '</span>' +
      '<span class="personalize-card__right">' +
        (price ? '<span class="personalize-card__price">' + price + '</span>' : '') +
        '<span class="personalize-card__chevron">&#8250;</span>' +
      '</span>';

    attachScrollAnimation(btn, 0);
  }

  function findAndTransform() {
    var btn = document.querySelector('button.pplr-c-button');
    if (btn) transformBtn(btn);
  }

  function setup() {
    findAndTransform();

    // Watch .product-personalizer for any re-renders Zepto may do after
    // its async scripts load, and re-apply the card immediately.
    var container = document.querySelector('.product-personalizer');
    if (!container) return;

    var observer = new MutationObserver(function () {
      findAndTransform();
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  // Zepto's canvas scripts load asynchronously after DOMContentLoaded,
  // so we hook into both events plus a short delay as a safety net.
  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
  setTimeout(setup, 800);
})();
